//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.div`
    position: absolute;
    width: 100%;
    top: calc(100% + 4px);
    z-index: 200;
    border-radius: 4px;
    border: 1px solid var(--purple-2);
    h4 {
        background-color: var(--purple-2);
        color: var(--light-1);
        margin: 0;
        padding: 18px 50px;
        font-size: 12px;
        text-align: center;
        border-top-left-radius: calc(inherit + 2px);
        border-top-right-radius: calc(inherit + 2px);
    }
`;
export const Content = styled.div`
    max-height: 180px;
    overflow-y: scroll;
    border-bottom-left-radius: calc(inherit + 2px);
    border-bottom-right-radius: calc(inherit + 2px);
    &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }
    &::-webkit-scrollbar-track {
        background-color: var(--light-1);
        border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb {
        border-radius: 2px;
        background-color: #00000035;
    }
`;
export const TimeItemGroup = styled.ol`
    display: flex;
    flex-direction: column;
    justify-content: center;
    list-style: none;
    width: 100%;
    margin: 0;
    padding: 0;
`;

export const TimeItem = styled.li`
    margin: 0;
    padding: 12px 60px;
    padding: 12px 0;
    font-size: 12px;
    color: var(--light-gray-5);
    background-color: var(--light-1);
    text-align: center;
    transition: 0.35s;
    cursor: pointer;
    &.selected {
        background-color: var(--purple-2);
        color: var(--light-1);
    }
    &.disabled {
        color: var(--light-4);
        pointer-events: none;
    }
`;